import { useTranslation } from 'react-i18next';
import { ReactElement } from 'react';
import { DrawerPanel } from '@dmc/ui';
import { CasFormFilePicker } from '@cas/components/inputs/cas-form-file-picker/CasFormFilePicker';
import { ModelName, QueryTag, TagList } from '@casops/store/api';
import { TagDescription } from '@reduxjs/toolkit/query';
import { FileUploadModel } from '@casops/store/apis/commonModels';
import ModelForm from '@casops/components/layout/model-form/ModelForm';
import useFileUploadForm from '@casops/components/layout/model-form/useFileUploadForm';

type FormModel = FileUploadModel;

const modelName = ModelName.LibraryItem;
const endpointUrl = 'api/library';
const tagsToClear: TagDescription<QueryTag>[] = [{ type: QueryTag.LibraryItem, id: TagList }];

const initialValues: FormModel = {
  file: undefined,
};

export function LibraryUploadPanel(): ReactElement {
  const { t } = useTranslation();

  const formProps = useFileUploadForm<FormModel>({
    endpointUrl,
    tagsToClear,
    defaultValues: initialValues,
    successMessage: t(`Model.Create.Success`, { modelName }),
  });

  return (
    <DrawerPanel header={t('LibraryUploadTitle')}>
      <ModelForm {...formProps} submitLabel={t('Upload')}>
        <CasFormFilePicker
          control={formProps.control}
          name="file"
          accept=".tgz,.tar.gz,.zip"
          minHeight="200px"
        />
      </ModelForm>
    </DrawerPanel>
  );
}

export default LibraryUploadPanel;
